import Vue from "vue";
import Router from "vue-router";
import Base from "@/student/layouts/Base";
import Store from "./store/store"
Vue.use(Router);
import StudentHome from "./pages/home/Home"
import PageNotFound from "@/common/components/PageNotFound.vue";
import Login from "@/common/pages/Login.vue";
import { homeRouteName } from "./constants/routes";

import startSessionRequests from "./utils/startSessionRequests.js";

const router = new Router({
    mode: "history",
    routes: [
      {
        path: "/",
        redirect: '/aluno'
      },
      {
        path: "/admin/login",
        component: Login,
        name: 'login',
      },
      {
        path: "/aluno",
        component: Base,
        children: [
            {
                path: "/",
                component: StudentHome,
                name: homeRouteName,
            },
            {
                path: "*",
                component: PageNotFound,
            },
        ]
    }, ],
});

router.beforeEach((to, from, next) => {

    /*AO ENTRAR NA ROTA SE O USUÁRIO NÃO ESTIVER SETADO TENTA PEGAR O USUÁRIO LOGADO*/
    if (!Store.state.auth.user && to.name != 'login') {
        Store.dispatch('isLoading');
        startSessionRequests()
            .then(() => {
                next();
            })
            .catch(() => {
                next({name:'login'});
            })
            .finally(() => Store.dispatch( 'isLoading', false ));
    } else {
        next();
    }
});

export default router;
